<template>
  <div style="display: flex; gap: 10px; align-items: center;">
    <div class="ai-box" v-show="item.scoreResult && item.scoreResult.doubleCircle" :data-title="$t('exam.iaText')">
      <p>AI</p>
      <span :class="item.scoreResult ? item.scoreResult.odStatus : ''"></span>
      <span :class="item.scoreResult ? item.scoreResult.osStatus : ''"></span>
    </div>
    <div class="ai-box" v-if="item.scoreResult && !item.scoreResult.doubleCircle" :data-title="$t('exam.iaText')">
      <p>AI </p>
      <span :class="item.scoreResult.odStatus ?? ''"></span>
    </div>
    <!-- Mutirão screens underserved sites with a high prevalence of eye disease, where
         several simultaneous findings are common and each clinically relevant on its own —
         this fully descriptive list (every class that cleared its threshold, not just the
         .ai-box pill's single highest-scoring one above) stays specifically for that case,
         opted into by whichever parent list actually has a mutirão context. -->
    <div class="alteration-list" v-if="showMutirao && item?.scoreResult?.allAlterationText">
      <template v-for="text in item.scoreResult.allAlterationText" :key="text">
        <b v-if="text === 'mcRASE2_c1'">
          {{ $t(text) }}
        </b>
        <span v-else>
          {{ $t(text) }}
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIScoreResult',
  props: {
    item: {
      type: Object,
      required: true
    },
    showMutirao: {
      type: Boolean,
      default: false
    }
  }
}
</script>
